import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {useStyles} from './helpers';
import {useRouter} from '../../../../../../../@casino/useRouter';

const TableCasino = ({allPage, perPage, columns, rows, changePage, changeRowsPerPage, width, pagination, route}) => {
    const classes = useStyles();
    const [rowsPerPage, setRowsPerPage] = React.useState(perPage);
    const router = useRouter();

    return (
        <div style={{width: '100%', maxWidth: width}}>
            <TableContainer className={classes.container} >
            <Table stickyHeader aria-label="sticky table" >
                <TableHead >
                <TableRow style={{height: 25}}>
                    {columns.map((column, key) => (
                    <TableCell
                        key={column.id}
                        align={column.align}
                        style={{minWidth: column.minWidth, borderBottom: '1px solid #3a4b7e', backgroundColor: 'inherit', color: '#ffce01', fontFamily: 'PT Sans, sans-serif', fontSize: 12, fontWeight: 700, padding: 0, paddingLeft: key === 0 ? 10 : 0, margin: 0 }}
                    >
                        {column.label}
                    </TableCell>
                    ))}
                </TableRow>
                </TableHead>
                <TableBody style={{width: '100%'}}>
                {rows.map((row, key) => {
                    
                    return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code} style={{background: key % 2 === 0 ? '#141b33' : '#1b2039', cursor: route ? 'pointer' : 'default'}}
                        onClick={() => {
                            if (route) {
                               router.history.push(route+row.id);
                            }
                        }}
                    >
                        {columns.map((column, key) => {
                        const value = row[column.id];
                    
                            return (
                                <TableCell key={column.id} align={column.align} 
                                    style={{
                                        border: 'none', 
                                        color: '#f3f3f4', 
                                        padding: 0, 
                                        margin: 0, 
                                        height: 30, 
                                        paddingLeft: key === 0 ? 10 : 0
                                    }}>
                                {column.format && typeof value === 'number' ? column.format(value) : value}
                                </TableCell>
                            );
                        })}
                    </TableRow>
                    );
                })}
                </TableBody>
                
                
            </Table>
            {
                    rows.length === 0 &&
                  
                    <div style={{width: '100%', height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <span style={{color: '#7aa0c7', fontFamily: 'Roboto, sans-serif', fontWeight: 700, fontSize: 12}}>Данных нет</span>
                    </div>
                
                }
            </TableContainer>
            {
                allPage >= rowsPerPage &&
                    <div style={{display: 'flex', justifyContent: 'center', marginTop: 12}}>
                        <span style={{cursor: 'pointer'}} onClick={() => {
                            setRowsPerPage(rowsPerPage + 5);
                            changeRowsPerPage({
                                page: 1,
                                rowsPerPage: rowsPerPage
                            });
                        }}>Показать еще</span>
                    </div>
            }
        </div>
    )
}

export default TableCasino;